// Source - https://stackoverflow.com/a/76692747
// Posted by Max Levytskyi
// Retrieved 2026-02-09, License - CC BY-SA 4.0

import { useState, useEffect } from "react";
import { useCurrentOrgId } from "../auth/authUtils";
import { useSelector } from "react-redux";

export function useLocalStorage(baseKey, initialValue) {
  const user = useSelector(state => state.auth?.user);
  const currentOrgId = useCurrentOrgId();
  const key = `${baseKey}-${user.id}-${currentOrgId}`;

  const [localValue, setLocalValue] = useState(() => {
    const storedValue = localStorage.getItem(key);

    return storedValue !== null ? JSON.parse(storedValue) : initialValue;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(localValue));
  }, [key, localValue]);

  return [localValue, setLocalValue];
}
